export default __webpack_public_path__ + "static/media/b63.82ac14a1.png";